import { ApiClient } from "#/shared/api/client";

export class DistanceFilterApi extends ApiClient {
  constructor({ baseURL }) {
    super({ baseURL, root: "common_places" });
  }
}

export const createDistanceFilterApi = ({ url }) => {
  const api = new DistanceFilterApi({ baseURL: url });

  return {
    getCommonPlaces: async () => api.get(""),
  };
};
